<!-- Header -->
<h3 mat-dialog-title>
    <span *ngIf="addProgram" translate>
        {{header|translate}}
    </span>
    <span *ngIf="!addProgram" translate>
        {{header|translate}}
    </span>
    <span style="float: right;" *ngIf="showSteps" translate>
        {{showSteps|translate}}
    </span>


</h3>

<!-- Body -->
<mat-dialog-content>

    <!-- Program and Service Form -->
    <form *ngIf="programAndService" id="programForm">
        <div class="program_row">
            <div class="program_colum">
                <!-- Program Code -->
                <tyl-form-field style="width:100%" label="Program">
                    <mat-select #programCodeField id='ddlProgramCode' [(ngModel)]='selectedProgramCode'
                        (selectionChange)="onProgramCodeChange()" name="ProgramCode" required>
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor='let pc of programCodes' [value]='pc'>
                            <span style="color: black !important;">{{pc.Code}}-{{pc.Description}}</span>
                        </mat-option>
                    </mat-select>
                </tyl-form-field>
            </div>
            <div class="program_colum">
                <!-- Service Code -->
                <tyl-form-field style="width:100%" label="Service">
                    <mat-select #serviceCodeField id='ddlServiceCode' [(ngModel)]='selectedServiceCodeId'
                        (selectionChange)="onServiceCodeChange()" name="ServiceCode" required>
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor='let sc of serviceCodes' [value]='sc.Id'>
                            <span style="color: black !important;">{{sc.Code}}-{{sc.Description}}</span>
                        </mat-option>
                    </mat-select>
                </tyl-form-field>
            </div>
        </div>

        <div class="program_row">
            <div [ngClass]="{'program_column': type == ''|| type =='Mass Enroll Into Service'}"
                [ngStyle]="{'width': type == '' || type =='Mass Enroll Into Service' ? '220px' : '100%'}">
                <!-- Entry Date -->
                <tyl-datepicker #entryDateField id="dtEntry" label="Entry Date" [(value)]="programAndService.EntryDate"
                    [isRequired]="true" style="width: 209px; padding-right: 10px;" [showTodayButton]="true">
                </tyl-datepicker>

                <!-- Exit Date -->
                <tyl-datepicker #exitDateField id="dtExit" label="Exit Date" [(value)]="programAndService.ExitDate"
                    [showTodayButton]="true" style="padding-right: 10px; width: 209px; vertical-align: center;"
                    [ngStyle]="{'padding-left': type == '' || type =='Mass Enroll Into Service' ? '0px' : '16px'}">
                </tyl-datepicker>
            </div>

            <!-- Comment -->
            <div class="program_column" style="width: 83%; " *ngIf="type == ''|| 'Mass Enroll Into Service' ">
                <tyl-form-field style="width: 100%;" appearance="outline" label="Comment"
                    hint="{{1000 - (programAndService.Comments ? programAndService.Comments.length : 0)}} characters left">
                    <textarea matInput #commentField [(ngModel)]='programAndService.Comments' name="Comment"
                        maxlength="1000" rows="2" style="height: 13vh; resize: none; "></textarea>
                </tyl-form-field>
            </div>
        </div>

        <div style="font-size: 15px; margin-top: 16px; display: flex; flex-wrap: wrap;" class="mat-dialog-title">
            Service-Specific Fields
        </div>
        <div style="display: flex; flex-wrap: wrap; flex-direction: row;">
            <div style="padding-right: 10px;margin-top: 10px"
                *ngFor="let field of programAndService.ProgramAndServicesDetail | orderBy: 'FieldName'">
                <program-and-service-fields [field]="field"></program-and-service-fields>
            </div>
        </div>

        <!-- Attachement  -->
        <div *ngIf="type == ''||'Mass Enroll Into Service'">
            <div style="font-size: 15px;" class="mat-dialog-title">Attachments</div>
            <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="attachmentTable"
                [attr.aria-label]="'attachments for program ' + programAndService.ProgramName + ' and service ' + programAndService.ServiceName">
                <!-- Description -->
                <ng-container matColumnDef="Description">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Description</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.AttachmentDescription}} </mat-cell>
                </ng-container>
                <!-- File  -->
                <ng-container matColumnDef="FileName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> File</mat-header-cell>
                    <mat-cell *matCellDef="let element"><a style="color:blue; text-decoration: underline;"
                            (click)="attachmentClick(element)">{{element.AttachmentFileName}}</a></mat-cell>
                </ng-container>
                <!-- UploadedOn -->
                <ng-container matColumnDef="UploadedOn">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded On</mat-header-cell>
                    <mat-cell *matCellDef="let element"><span> {{element.AttachmentAddedOn | date: 'MM/dd/yy'}}</span>
                    </mat-cell>
                </ng-container>
                <!-- UploadedBy -->
                <ng-container matColumnDef="UploadedBy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <span> {{element.AttachmentAddedBy}}</span>
                    </mat-cell>
                </ng-container>
                <!-- Actions -->
                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;">
                        <a id="deleteAttachment{{i}}" [ngClass]="{'linkDisabled': readOnly}"
                            style="font-size:10pt;cursor:pointer;text-decoration:underline;"
                            (click)="deleteAttachmentClick(element)">Delete</a>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                    id="attachmentTableDataRow{{i}}" style="padding:0px;overflow: hidden;" matRipple>
                </mat-row>
            </mat-table>
        </div>
    </form>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="footerLeft" *ngIf="showSteps != null">

        <tyl-button [image]="backButtonImage" [label]="backButtonLabel" (clickEvent)="backClick()"></tyl-button>
    </div>

    <div class="footerLeft" *ngIf="type ==''|| 'Mass Enroll Into Service'">

        <tyl-button image="Add.png" label="Add Attachment" (click)="addAttachmentClick();" *ngIf="userCanEditPrograms">
        </tyl-button>
    </div>
    <!-- Right Buttons -->
    <div class="footerRight">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button [image]="okButtonImage" [label]="okButtonLabel" (clickEvent)="save(); validationTrigger.click();">
        </tyl-button>

        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>

<!-- Form Validation Trigger -->
<input style="display: none" type="submit" form="programForm" #validationTrigger>
